import React from 'react'
import styles from "../tnpsc-admissions/tnpsc-admissions.module.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const About_TNPSC = () => {
  
     useEffect(() => {
          AOS.init({
            duration: 800,
            easing: "ease-in-out",
            once: true,
            offset: 100,
          });
        }, []);
    
       
      
  return (
    <>      <section id="examcriteria">
                <div className="container">
                        <div className="row pt-2">
                            <div className="col">
                            <p className={`${styles.pagemaintitles}`}>About the Exam</p>
                            <p className={`${styles.aboutheading2}`}>(Group wise Eligibility, Exam Pattern and Syllabus.)</p>
                            </div>
                        </div>
                    </div>

                    <div className="container">

                        {/*General Stidies Section*/}
                        <div className="row ">
                            <div data-aos="fade-down" className="col-md-6 col-12 ">
                                <div className={styles.newcardBox}>

                                    <h2 className={styles.newsectiontitle}>Group I</h2>
                                    <p className={styles.newcardSub}>DC, DSP, Others</p>

                                    <div className={styles.innerBox}>
                                    <p className={styles.innerTitle}>Eligibility</p>

                                    {[
                                        ["Minimum Age", "21 Years"],
                                        ["Maximum Age (OC)", "32 years , 33 years (Law Degree)"],
                                        ["Maximum Age (Others)", "37 years, 38 years (Law Degree)"],
                                        ["Qualification", "UG in any Degree"]
                                    ].map((item, i) => (
                                        <div key={i} className={styles.infoRow}>
                                        <span className={styles.infoLabel}>{item[0]}</span>
                                        <span className={styles.infoValue}>{item[1]}</span>
                                        </div>
                                    ))}
                                    </div>

                                </div>
                            </div>
               
                            <div data-aos="fade-down" className="col-md-6 col-12 mb-3">
                                <div className={styles.newcardBox}>
                                <h2 className={styles.newsectiontitle}>Group II/IIA</h2>
                                <p className={styles.newcardSub}>Deputy State Tax Officer</p>
                                 <div className={styles.innerBox}>
                                    <p className={styles.innerTitle}>Eligibility</p>

                                    {[
                                        ["Minimum Age", "18/20 Years"],
                                        ["Maximum Age (OC)", "30 Years"],
                                        ["Maximum Age (Others)", "No maximum age limit"],
                                        ["Qualification", "UG in any Degree"]

                                    ].map((item, i) => (
                                        <div key={i} className={styles.infoRow}>
                                        <span className={styles.infoLabel}>{item[0]}</span>
                                        <span className={styles.infoValue}>{item[1]}</span>
                                        </div>
                                    ))}

                                </div>
                            </div>
                           </div>
                        </div>
                    </div>

                    <div className="container pt-2">
                        {/*General Stidies Section*/}
                        <div className="row">
                            <div data-aos="fade-down" className="col-md-6 col-12 mb-3 pt-3">
                                <div className={`${styles.newcardBox}  d-flex flex-column`}>
                                    <p className={styles.newsectiontitle}>Exam Pattern</p>
                                    <p className={styles.newcardSub}>Stage I : (Preliminary – Objective Type)</p>
                                    <div className="flex-grow-1 d-flex flex-column "> 
                                    <div className={styles.innerBox1}>
                                        {[
                                            ["Subject", "General Studies(175)+Mental Ability(25)"],
                                            ["Questions", "200"],
                                            ["Marks", "300 (3 hours)"],
                                            ["Qualification", "UG in any Degree"]

                                        ].map((item, i) => (
                                            <div key={i} className={styles.infoRow}>
                                            <span className={styles.infoLabel}>{item[0]}</span>
                                            <span className={styles.infoValue}>{item[1]}</span>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="pt-3">
                                        <p className={styles.newcardSub}>Stage II (Mains - Descriptive)</p>
                                    </div>            

                                    <div className={styles.innerBox1}>
                                        {[
                                            ["Subject", "Paper I (Tamil Eligibility Test)"],
                                            ["Marks", "100"],
                                            ["Time", "3 hours (each)"]

                                        ].map((item, i) => (
                                            <div key={i} className={styles.infoRow}>
                                                <span className={styles.infoLabel}>{item[0]}</span>
                                                <span className={styles.infoValue}>{item[1]}</span>
                                            </div>
                                        ))}
                                        <br/>

                                        {[
                                            ["Subject", "Paper II, III, IV"],
                                            ["Marks", "750 (each 250)"],
                                            ["Time", "3 hours(each)"]

                                        ].map((item, i) => (
                                            <div key={i} className={styles.infoRow}>
                                                <span className={styles.infoLabel}>{item[0]}</span>
                                                <span className={styles.infoValue}>{item[1]}</span>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="pt-3">
                                        <p className={styles.newcardSub}>Stage III (Interview)</p>
                                    </div> 

                                    <div className={styles.innerBox1}>
                                        {[
                                            ["Subject", "Interview and Records"],
                                            ["Marks", "100"], 

                                        ].map((item, i) => (
                                            <div key={i} className={styles.infoRow}>
                                                <span className={styles.infoLabel}>{item[0]}</span>
                                                <span className={styles.infoValue}>{item[1]}</span>
                                            </div>
                                        ))}
                                    </div> 
                                    </div>
                                </div>
                            </div>

                            <div data-aos="fade-down" className="col-md-6 col-12 mb-3 pt-3">
                                <div className={`${styles.newcardBox} d-flex flex-column`}>
                                    <p className={styles.newsectiontitle}>Exam Pattern</p>
                                    <p className={styles.newcardSub}>Stage I : (Preliminary – Objective Type)</p>
                                    <div className="flex-grow-1 d-flex flex-column"> 
                                        <div className= {`${styles.innerBox1} pt-4`}  >
                                            {[
                                                ["Subject", "General Studies(175)+Mental Ability(25)"],
                                                ["Questions", "200"],
                                                ["Marks", "300 (3 hours)"],
                                                    
                                            ].map((item, i) => (
                                                <div key={i} className={styles.infoRow}>
                                                    <span className={styles.infoLabel}>{item[0]}</span>
                                                    <span className={styles.infoValue}>{item[1]}</span>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="pt-3">
                                            <p className={styles.newcardSub}>Stage II (Mains - Descriptive)</p>
                                        </div>            

                                        <div className={styles.innerBox1}>
                                            {[
                                                    ["Subject", "Paper I (Tamil Eligibility Test)"],
                                                    ["Marks", "100"],
                                                    ["Time", "3 hours"]

                                                ].map((item, i) => (
                                                    <div key={i} className={styles.infoRow}>
                                                        <span className={styles.infoLabel}>{item[0]}</span>
                                                        <span className={styles.infoValue}>{item[1]}</span>
                                                    </div>
                                            ))}

                                            <br/>

                                            <div className="pt-3">
                                                <p className={styles.newcardSub1}>Paper II Mains - Objective (Computer Based Test)</p>
                                            </div> 

                                            {[       
                                                ["Marks", "300"],
                                                ["Time", "3 hours"]

                                            ].map((item, i) => (
                                                <div key={i} className={styles.infoRow}>
                                                    <span className={styles.infoLabel}>{item[0]}</span>
                                                    <span className={styles.infoValue}>{item[1]}</span>
                                                </div>
                                            ))}
                                        </div>

                                            <div className="pt-3">
                                                <p className={styles.newcardSub}>Stage III (Interview)</p>
                                            </div> 

                                            <div className={styles.innerBox1}>
                                                {[
                                                    ["Subject", "Oral Test"],
                                                    ["Questions", "40"],

                                                ].map((item, i) => (
                                                    <div key={i} className={styles.infoRow}>
                                                    <span className={styles.infoLabel}>{item[0]}</span>
                                                    <span className={styles.infoValue}>{item[1]}</span>
                                                    </div>
                                                ))}
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    <div className="container">
                        {/*General Studies Section*/}
                        <div className="row">
                            <div data-aos="fade-down" className="col-md-6 col-12 ">
                                <div className={styles.newcardBox}>

                                    <h2 className={styles.newsectiontitle}>Group II</h2>
                                    <p className={styles.newcardSub}>Sub Registrar, PO, JEO and all Other Posts</p>

                                    <div className={`${styles.innerBox} pt-5`}>
                                    <p className={styles.innerTitle}>Eligibility</p>

                                    {[
                                        ["Minimum Age", "21 Years"],
                                        ["Maximum Age (Others)", "No maximum age limit"],
                                        ["Qualification", "UG in any Degree"]
                                    ].map((item, i) => (
                                        <div key={i} className={styles.infoRow}>
                                        <span className={styles.infoLabel}>{item[0]}</span>
                                        <span className={styles.infoValue}>{item[1]}</span>
                                        </div>
                                    ))}
                                    </div>

                                </div>
                            </div>

                            <div data-aos="fade-down" className="col-md-6 col-12 mb-3">
                                <div className={styles.newcardBox}>
                                <h2 className={styles.newsectiontitle}>Group IIA</h2>
                                <p className={styles.newcardSub}>Asst. Personal Clerks in various departments</p>
                                 <div className={styles.innerBox}>
                                    <p className={styles.innerTitle}>Eligibility</p>

                                    {[
                                        ["Minimum Age", "18/20 Years"],
                                        ["Maximum Age (OC)", "30 Years"],
                                        ["Maximum Age (Others)", "No maximum age limit"],
                                        ["Qualification", "UG in any Degree"]

                                    ].map((item, i) => (
                                        <div key={i} className={styles.infoRow}>
                                        <span className={styles.infoLabel}>{item[0]}</span>
                                        <span className={styles.infoValue}>{item[1]}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                           </div>
                        </div>
                    </div>

                    {/* <div className="container pt-2 pt-md-3">
                           
                            <div className="row">
                                <div className="col-md-6 col-12 mb-3 pt-3">
                                    <div className="p-3" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading1} mb-0`}>Exam Pattern</p>
                                        <p className={`${styles.aboutheading2} pt-2 mb-0`}>Stage I : (Preliminary – Objective Type)</p>

                                            <div className="row pt-3">
                                                <div className="col-4">
                                                    <p className={`${styles.acheiverrank}`}>Subject</p>
                                                </div>
                                                <div className="col-8">
                                                    <p className={`${styles.aboutnumber}`}>General Studies(175)+ General Tamil / English</p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-4">
                                                    <p className={`${styles.acheiverrank}`}>Questions</p>
                                                </div>
                                                <div className="col-8">
                                                    <p className={`${styles.aboutnumber}`}>200</p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-4">
                                                    <p className={`${styles.acheiverrank}`}>Marks</p>
                                                </div>
                                                <div className="col-8">
                                                    <p className={`${styles.aboutnumber}`}>300 (3 hours)</p>
                                                </div>
                                            </div>
                                            <hr></hr>

                                            <p className={`${styles.aboutheading2} mb-0`}>Stage II (Mains - Descriptive)</p>
                                            <div className="row pt-3">
                                                <div className="col-4">
                                                    <p className={`${styles.acheiverrank}`}>Subject</p>
                                                </div>
                                                <div className="col-8">
                                                    <p className={`${styles.aboutnumber}`}>Paper I</p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-4">
                                                    <p className={`${styles.acheiverrank}`}>Marks</p>
                                                </div>
                                                <div className="col-8">
                                                    <p className={`${styles.aboutnumber}`}>300</p>
                                                </div>
                                            </div>
                                            
                                            <div className="row">
                                                <div className="col-4">
                                                    <p className={`${styles.acheiverrank}`}>Time</p>
                                                </div>
                                                <div className="col-8">
                                                    <p className={`${styles.aboutnumber}`}>3 hours</p>
                                                </div>
                                            </div>
                                            <hr></hr>


                                            <p className={`${styles.aboutheading2} mb-0`}>Stage III (Interview)</p>
                                            <div className="row pt-3">
                                                <div className="col-4">
                                                    <p className={`${styles.acheiverrank}`}>Subject</p>
                                                </div>
                                                <div className="col-8">
                                                    <p className={`${styles.aboutnumber}`}>Oral-Personal Interview</p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-4">
                                                    <p className={`${styles.acheiverrank}`}>Marks</p>
                                                </div>
                                                <div className="col-8">
                                                    <p className={`${styles.aboutnumber}`}>40</p>
                                                </div>
                                            </div>



                                    </div>
                                </div>

                                <div className="col-md-6 col-12 mb-3 pt-3">
                                    <div className="p-3 h-100" style={{border: "1px solid #D9DFE6"}}>
                                        <p className={`${styles.aboutheading1} mb-0`}>Exam Pattern</p>
                                        <p className={`${styles.aboutheading2} pt-2 mb-0`}>Stage I : (Preliminary – Objective Type)</p>
                                        <div className="row pt-3">
                                                <div className="col-4">
                                                <p className={`${styles.acheiverrank}`}>Subject</p>
                                                </div>
                                                <div className="col-8">
                                                <p className={`${styles.aboutnumber}`}>General Studies(175)+ Mental Ability(25)</p>
                                                </div>
                                        </div>
                                        <div className="row">
                                                <div className="col-4">
                                                <p className={`${styles.acheiverrank}`}>Questions</p>
                                                </div>
                                                <div className="col-8">
                                                <p className={`${styles.aboutnumber}`}>200</p>
                                                </div>
                                        </div>
                                        <div className="row">
                                                <div className="col-4">
                                                <p className={`${styles.acheiverrank}`}>Marks</p>
                                                </div>
                                                <div className="col-8">
                                                <p className={`${styles.aboutnumber}`}>300 (3 hours)</p>
                                                </div>
                                        </div>
                                        <hr></hr>


                                        <p className={`${styles.aboutheading2} mb-0`}>Stage II (Mains - Descriptive)</p>
                                        <div className="row pt-3">
                                                <div className="col-4">
                                                <p className={`${styles.acheiverrank}`}>Subject</p>
                                                </div>
                                                <div className="col-8">
                                                <p className={`${styles.aboutnumber}`}>Paper I</p>
                                                </div>
                                        </div>
                                        <div className="row">
                                                <div className="col-4">
                                                <p className={`${styles.acheiverrank}`}>Marks</p>
                                                </div>
                                                <div className="col-8">
                                                <p className={`${styles.aboutnumber}`}>300</p>
                                                </div>
                                        </div>
                                        <div className="row">
                                                <div className="col-4">
                                                <p className={`${styles.acheiverrank}`}>Time</p>
                                                </div>
                                                <div className="col-8">
                                                <p className={`${styles.aboutnumber}`}>3 hours</p>
                                                </div>
                                        </div>
                                        <hr></hr>


                                        <p className={`${styles.aboutheading2} mb-0`}>(no Interview)</p>
                                        <div className="row pt-3">
                                                <div className="col-4">
                                                {/* <p className={`${styles.acheiverrank}`}>Subject</p> 
                                                </div>
                                                <div className="col-8">
                                                {/* <p className={`${styles.aboutnumber}`}>Oral Test</p> 
                                                </div>
                                        </div>

                                        <div className="row">
                                                <div className="col-4">
                                                {/* <p className={`${styles.acheiverrank}`}>Marks</p> 
                                                </div>
                                                <div className="col-8">
                                                {/* <p className={`${styles.aboutnumber}`}>40</p> 
                                                </div>
                                        </div>
                                        
                                        
                                    </div>
                                </div>

                            </div>
                    </div> */}
            </section>
    </>
  )
}

export default About_TNPSC;